<template>
        <div class="media-content p-4">
          <div class="content has-text-left">
            <div>
              <h3 class="h3"><strong>{{ center.name }}</strong></h3>
              <div v-for="address in center.address" :key="address">
                {{ address }}
              </div>
              {{ center.postcode }}
              <br>
              <br>
              {{ center.distance && `${center.distance} miles away`}}
              <b-tag class="is-blue-light" v-if="nearest && center.distance">Nearest</b-tag>
            </div>
          </div>
          <nav class="level is-mobile">
              <a class="level-item" aria-label="reply">
                <template>
                  <router-link class="is-info is-fullwidth"
                  tag="b-button" v-bind:to="'/book-citb-test/' + center.id">
                    Book Test in {{center.shortName}}
                  </router-link>
                </template>
              </a>
          </nav>
        </div>
</template>

<script>
export default {
  name: 'CenterCard',
  props: {
    nearest: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Object,
      default: () => ({
        id: '1',
        name: 'N/A',
        address: [
          'N/A',
        ],
        postcode: 'usyd78h',
      }),
    },
  },
};
</script>

<style scoped>
.is-blue-light {
  background-color: #EFF5FB;
  color: #296FA7;
}
</style>
